import { action, computed, observable } from 'mobx';

type ContractType = 'smas' | 'no_smas' | 'overseas_24h_option_user' | 'non_overseas_24h_option_user';

const CONTRACT_TYPE_LABELS: Record<ContractType, string> = {
  smas: 'レンタカーSMAS利用企業',
  no_smas: 'レンタカーSMAS利用企業以外',
  overseas_24h_option_user: '海外24時間365日オプション利用企業',
  non_overseas_24h_option_user: '海外24時間365日オプション利用企業以外'
};

export type IndividualOptionSuppliedItemResponseArgs = {
  id: number;
  contract_type: ContractType;
  supplied_item_id?: number;
  supplied_item_name?: string;
  supplier_name?: string;
  supplied_item_disabled?: boolean;
};

type IndividualOptionSuppliedItemArgs = {
  id: number;
  contractType: ContractType;
  suppliedItemId: number | null;
  suppliedItemName: string | null;
  supplierName: string | null;
  suppliedItemDisabled: boolean;
};

export const convertIndividualOptionSuppliedItemResponseToArgs = (
  response: IndividualOptionSuppliedItemResponseArgs
): IndividualOptionSuppliedItemArgs => ({
  id: response.id,
  contractType: response.contract_type,
  suppliedItemId: response.supplied_item_id || null,
  suppliedItemName: response.supplied_item_name || null,
  supplierName: response.supplier_name || null,
  suppliedItemDisabled: response.supplied_item_disabled || false
});

export default class IndividualOptionSuppliedItem {
  @observable id: number;
  @observable contractType: ContractType;
  @observable suppliedItemId: number | null;
  @observable suppliedItemName: string | null;
  @observable supplierName: string | null;
  @observable suppliedItemDisabled: boolean;

  constructor(args: IndividualOptionSuppliedItemArgs) {
    this.id = args.id;
    this.contractType = args.contractType;
    this.suppliedItemId = args.suppliedItemId;
    this.suppliedItemName = args.suppliedItemName;
    this.supplierName = args.supplierName;
    this.suppliedItemDisabled = args.suppliedItemDisabled;
  }

  @computed
  get contractTypeLabel() {
    return CONTRACT_TYPE_LABELS[this.contractType];
  }

  @action
  setSuppliedItemId(id: number | null) {
    this.suppliedItemId = id;
    this.suppliedItemDisabled = false;
  }

  submitParams() {
    return {
      supplied_item_id: this.suppliedItemId
    };
  }
}
